import { IDataAverage } from '@/pages/Analytics/components/AverageRate';
import { IResponseApi } from '@/types/apis/response';
import { useMemo } from 'react';

export const useDataAverageAnalytic = (
  data: IResponseApi.IAnalytic[],
  appliedProducts?: IResponseApi.IProductAnalytic[],
  totalActiveRules?: number,
) => {
  const dataAverageRate: IDataAverage = useMemo(() => {
    let result = {
      addToCartRate: 0,
      clickThroughRate: 0,
      engagementRate: 0,
      activeRules: 0,
      products: 0,
      PDPVisits: 0,
      impressions: 0,
      hovers: 0,
      clicks: 0,
      addToCart: 0,
    };

    data.forEach((item) => {
      result.PDPVisits += item.totalVisitorsProductPage || 0;
      result.impressions += item.totalBannerImpressions || 0;
      result.hovers += item.totalHoverBannerETA || 0;
      result.clicks += item.totalBannerClicks || 0;
      result.addToCart += item.totalAddToCart || 0;
    });

    result.addToCartRate = +((result.addToCart / (result.PDPVisits || 1)) * 100).toFixed(2);
    result.clickThroughRate = +((result.clicks / (result.impressions || 1)) * 100).toFixed(2);
    result.engagementRate = +(((result.clicks + result.hovers + result.addToCart) / (result.impressions || 1)) * 100).toFixed(2);
    result.activeRules = totalActiveRules || 0;
    let tempProduct = 0;

    const ruleSelectedAllProducts = appliedProducts?.find((item) => item?.isAllProducts);
    if (ruleSelectedAllProducts) {
      result.products = ruleSelectedAllProducts.totalProducts;
    } else {
      appliedProducts?.forEach((item) => {
        tempProduct += item.totalProducts || 0;
      });

      result.products = tempProduct;
    }

    return result;
  }, [data, appliedProducts, totalActiveRules]);
  return dataAverageRate;
};
